import { Col, Form, InputNumber, Row, Select } from 'antd'
import { BoosterRewardType } from 'Modules'

import SelectPto from 'component/select/select-pto'
import {
  BOOSTER_CODE_EXPIRY_OPTIONS,
  BOOSTER_PROGRAM_FIELD_MAX_LENGTH,
  BOOSTER_PROGRAM_MESSAGES,
  BOOSTER_REWARD_TYPE_OPTIONS,
} from 'constants/booster-program'

import { HorizontalRow } from './horizontal-row'
import { MilestoneRewardFields } from './milestone-reward-fields'
import { buildName } from './utils'

const MAX = BOOSTER_PROGRAM_FIELD_MAX_LENGTH

/** PTO selling status — 0 = on sale, 1 = sold out (mirrors BE `soldOutStatus`). */
const PTO_SOLD_OUT_STATUS = { ON_SALE: 0, SOLD_OUT: 1 } as const

interface Props {
  /** Optional Form.List index. When undefined, names are top-level (standalone form). */
  parentName?: number
  rewardType?: BoosterRewardType
}

export const MilestoneFieldsBlock = ({ parentName, rewardType }: Props) => {
  return (
    <Row gutter={[32, 0]}>
      <Col xs={24} lg={12}>
        <HorizontalRow label="Reward Type" required>
          <Form.Item
            name={buildName(parentName, 'rewardType')}
            rules={[{ required: true, message: 'Reward type is required' }]}
            style={{ marginBottom: 0, maxWidth: 280 }}
          >
            <Select placeholder="Select reward type" options={BOOSTER_REWARD_TYPE_OPTIONS} />
          </Form.Item>
        </HorizontalRow>

        <HorizontalRow label="Total Supply" required>
          <Form.Item
            name={buildName(parentName, 'totalSupply')}
            rules={[
              { required: true, message: 'Total Supply is required' },
              {
                type: 'number',
                min: 1,
                message: BOOSTER_PROGRAM_MESSAGES.E01('Total supply'),
              },
              {
                type: 'number',
                max: 1_000_000,
                message: BOOSTER_PROGRAM_MESSAGES.E06('Total supply'),
              },
            ]}
            style={{ marginBottom: 0, maxWidth: 280 }}
          >
            <InputNumber
              min={1}
              max={1_000_000}
              maxLength={MAX.totalSupply}
              placeholder="Input number"
              style={{ width: '100%' }}
            />
          </Form.Item>
        </HorizontalRow>

        <HorizontalRow label="Code Expiry" required>
          <Form.Item
            name={buildName(parentName, 'codeExpiry')}
            rules={[{ required: true, message: 'Code Expiry is required' }]}
            style={{ marginBottom: 0, maxWidth: 280 }}
          >
            <Select options={BOOSTER_CODE_EXPIRY_OPTIONS} />
          </Form.Item>
        </HorizontalRow>

        <HorizontalRow label="Linked PTOs" required>
          <Form.Item
            name={buildName(parentName, 'linkedPtos')}
            rules={[{ required: true, message: 'Linked PTOs is required' }]}
            style={{ marginBottom: 0 }}
          >
            <SelectPto
              mode="multiple"
              soldOut={PTO_SOLD_OUT_STATUS.ON_SALE}
              placeholder="Search PTO"
              pageSize={100}
              maxTagCount="responsive"
            />
          </Form.Item>
        </HorizontalRow>
      </Col>

      <Col xs={24} lg={12}>
        <MilestoneRewardFields parentName={parentName} rewardType={rewardType} />
      </Col>
    </Row>
  )
}
